module.exports = __webpack_public_path__ + "img/line.c9f34bd.svg";